import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import * as userActions from "../actions/userActions";
import { scAxiosAdmin } from "../";
import { API_TOKEN_NAME } from "../constants";
import PrivateRoute from "../PrivateRoute.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import appointments from "./dashboard/appointments";
import admindashboard from "./admin/admindashboard";
import newsevents from "./admin/newsevents";
//import addnewsevents from './admin/addnewsevents';
import doctors from "./admin/doctors";
import adddoctor from "./admin/adddoctor";
import editdoctor from "./admin/editdoctor";
import departments from "./admin/departments";
import adddepartment from "./admin/adddepartment";
import editdepartment from "./admin/editdepartment";
import testimonials from "./admin/testimonials";
import edittestimonial from "./admin/edittestimonial";
import addtestimonial from "./admin/addtestimonial";
import editnewsevent from "./admin/editnewsevent";
import addnewsevent from "./admin/addnewsevent";
import publications from "./admin/publications";
import addpublication from "./admin/addpublication";
import editpublication from "./admin/editpublication";
import doctorView from "./admin/doctorView";
import departmentView from "./admin/departmentView";
import testimonialView from "./admin/testimonialView";
import newsEventsView from "./admin/newsEventsView";
import publicationView from "./admin/publicationView";
import packages from "./admin/packages";
import addpackage from "./admin/addpackage";
import editpackage from "./admin/editpackage";
import PackageView from "./admin/PackageView";
import staticpages from "./admin/staticpages";
import addstaticpage from "./admin/addstaticpage";
import editpage from "./admin/editpage";
import page from "./admin/page";
import menu from "./admin/menu";
import addmenu from "./admin/addmenu";
import editmenu from "./admin/editmenu";
import bannerbuttonlink from "./admin/bannerbuttonlink";
import addbannerbuttonlink from "./admin/addbannerbuttonlink";
import editbannerbuttonlink from "./admin/editbannerbuttonlink";
import addVideoGallery from "./admin/addVideoGallery";
import addbodylink from "./admin/addbodylink";
import BodyLinkDept from "./admin/BodyLinkDept";
import EditBodyLink from "./admin/EditBodyLink";
//import ViewBodyLink from './admin/ViewBodyLink';
import headerannoucement from "./admin/headerannoucement";
import addheaderannoucement from "./admin/addheaderannoucement";
import editheaderannoucement from "./admin/editheaderannoucement";
import addAlbum from "./admin/addAlbum";
import EditAlbum from "./admin/editAlbum";
import EditVideoGallery from "./admin/editVideoGallery";
import Albums from "./admin/albums";
import Videogallery from "./admin/videogallery";
import adminRolePermission from "./admin/adminRolePermission";
import board from "./admin/board.js";
import addboardmember from "./admin/addboardmember.js";
import editboardmember from "./admin/editboardmember.js";
import bookingrequest from "./admin/bookingrequest.js";
import uploading from "./admin/uploading.js";
import Settings from "./admin/Settings.js";

import CaseStudies_list from "./admin/CaseStudies_list.js";
import CaseStudies_create from "./admin/CaseStudies_create.js";
import CaseStudies_update from "./admin/CaseStudies_update.js";
import setSSLConfig from "./admin/setSSLConfig.js";
import roleManager from "./admin/roleManager.js";
import UserLog from "./admin/user_log.js";
import error from "./admin/error.js";

import JobCircular_list from "./admin/job/JobCircular_list.js";
import JobCircular_create from "./admin/job/JobCircular_create.js";
import JobCircular_update from "./admin/job/JobCircular_update.js";

import Banner_list from "./admin/Banner_list.js";
import Banner_create from "./admin/Banner_create.js";
import Banner_update from "./admin/Banner_update.js";

import EmergencyInquiryMessages from "./admin/EmergencyInquiryMessages.js";

import UserChangePassword from "./admin/UserChangePassword.js";
import Investigations from "./admin/Investigations.js";
import EditInvestigation from "./admin/EditInvestigation.js";
import AddInvestigation from "./admin/AddInvestigation.js";
import MediaUpload from "./admin/MediaUpload.js";
import HomePopup from "./admin/HomePopup.js";
import Configuration from "./admin/Configuration.js";
import EmailConfiguration from "./admin/EmailConfiguration.js";
import AddMegaStaticPage from "./admin/AddMegaStaticPage.js";
import UpdateMegaStaticPage from "./admin/UpdateMegaStaticPage.js";
import homesamplecollection from "./admin/homesamplecollection.js";

const getUserDeatils = () => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/user/detail/1", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
class Dashboard extends React.Component {
  state = {
    //isprofilecomplete: '',
    user_role: "",
  };
  componentDidMount() {
    getUserDeatils()
      .then((res) => {
        if (res.status === true) {
          var userdata = res.data;
          this.setState({
            //isprofilecomplete: userdata.isprofilecomplete,
            user_role: userdata.role,
          });
        } else {
          toast.error(res.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  render() {
    let user_role = this.state.user_role;
    let userlink;
    //let isprofilecomplete = this.state.isprofilecomplete;
    if (user_role === "1") {
      userlink = (
        <div>
          <Route />
          <Switch>
            <PrivateRoute
              path="/editalbum/:id"
              component={EditAlbum}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/headerannoucement"
              component={headerannoucement}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editheaderannoucement/:id"
              component={editheaderannoucement}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addheaderannoucement"
              component={addheaderannoucement}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editbannerbuttonlink/:id"
              component={editbannerbuttonlink}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addbannerbuttonlink"
              component={addbannerbuttonlink}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/bannerbuttonlink"
              component={bannerbuttonlink}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/staticpages"
              component={staticpages}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addstaticpage"
              component={AddMegaStaticPage}
              // component={addstaticpage}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editpage/:id"
              component={editpage}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/editpage/:id"
              component={UpdateMegaStaticPage}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/page/:id"
              component={page}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/menu"
              component={menu}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addmenu"
              component={addmenu}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editmenu/:id"
              component={editmenu}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/packages"
              component={packages}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/edit-investigation/:id"
              component={EditInvestigation}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/investigations"
              component={Investigations}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/add-investigations"
              component={AddInvestigation}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/addpackage"
              component={addpackage}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editpackage/:id"
              component={editpackage}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/viewpackage/:id"
              component={PackageView}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/body-links"
              component={BodyLinkDept}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/addbodylink"
              component={addbodylink}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/editbodylink/:id"
              component={EditBodyLink}
              user={this.props.user}
              exact
            />
            {/*<PrivateRoute path='/viewbodylink/:id' component={ViewBodyLink} user={this.props.user} exact />*/}
            <PrivateRoute
              path="/viewdoctor/:id"
              component={doctorView}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/viewdepartment/:id"
              component={departmentView}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/viewtestimonial/:id"
              component={testimonialView}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/viewnewsevent/:id"
              component={newsEventsView}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/viewpublication/:id"
              component={publicationView}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/edittestimonial/:id"
              component={edittestimonial}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editvideogallery/:id"
              component={EditVideoGallery}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addvideogallery"
              component={addVideoGallery}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addtestimonial"
              component={addtestimonial}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/testimonials"
              component={testimonials}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addpublication"
              component={addpublication}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/editpublication/:id"
              component={editpublication}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/publications"
              component={publications}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/upload-media"
              component={MediaUpload}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/home-popup"
              component={HomePopup}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/appointment/request"
              component={bookingrequest}
              user={this.props.user}
              type="request_appointment"
              exact
            />
            <PrivateRoute
              path="/admin/appointment/booking"
              component={bookingrequest}
              user={this.props.user}
              type="book_appointment"
              exact
            />
            <PrivateRoute
              path="/admin/uploading"
              component={uploading}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editdepartment/:id"
              component={editdepartment}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/adddepartment"
              component={adddepartment}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addboardmember"
              component={addboardmember}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editboardmember/:id"
              component={editboardmember}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/departments"
              component={departments}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/editdoctor/:id"
              component={editdoctor}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addalbum"
              component={addAlbum}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/adddoctor"
              component={adddoctor}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/doctors"
              component={doctors}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/boardmembers"
              component={board}
              user={this.props.user}
              exact
            />
            {/*<PrivateRoute path='/addnewsevents' component={addnewsevents} user={this.props.user} exact />*/}
            <PrivateRoute
              path="/editnewsevent/:id"
              component={editnewsevent}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/addnewsevent"
              component={addnewsevent}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/newsevents"
              component={newsevents}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admindashboard"
              component={admindashboard}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/role-permission/:id"
              component={adminRolePermission}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/albums"
              component={Albums}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/videogallery"
              component={Videogallery}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/email-configuration"
              component={EmailConfiguration}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/configuration"
              component={Configuration}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/settings"
              component={Settings}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/admin/case_studies"
              component={CaseStudies_list}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/case_studies_create"
              component={CaseStudies_create}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/case_studies_update/:id"
              component={CaseStudies_update}
              user={this.props.user}
              exact
            />

            {/* Job Circular */}
            <PrivateRoute
              path="/admin/job/list"
              component={JobCircular_list}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/job/create"
              component={JobCircular_create}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/job/update/:id"
              component={JobCircular_update}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/admin/banner/list"
              component={Banner_list}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/banner/create"
              component={Banner_create}
              user={this.props.user}
              exact
            />
            <PrivateRoute
              path="/admin/banner/update/:id"
              component={Banner_update}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/admin/set_ssl_commerz"
              component={setSSLConfig}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/admin/role-manager"
              component={roleManager}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/admin/user-log"
              component={UserLog}
              user={this.props.user}
              exact
            />

            <PrivateRoute
              path="/admin/emergency-inquiry-messages"
              component={EmergencyInquiryMessages}
              user={this.props.user}
              exact
            />

            {/* <PrivateRoute
              path="/admin/change-password"
              component={UserChangePassword}
              user={this.props.user}
              exact
            /> */}

            <PrivateRoute
              path="/admin/error"
              component={error}
              user={this.props.user}
              exact
            />

            <Redirect to="/admindashboard" />
          </Switch>
        </div>
      );
    }
    if (user_role === "2") {
      userlink = (
        <div>
          <Route />
          <Switch>
            <PrivateRoute
              path="/appointments"
              component={appointments}
              user={this.props.user}
              exact
            />
            <Redirect to="/appointments" />
          </Switch>
        </div>
      );
    }
    return <div>{userlink}</div>;
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(userActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/component/dashboard.js